import React from 'react';
import { Link } from 'react-router-dom';
import SITE_CONFIG from '../../config/site.config';

const Header = ({ isAdmin = false }) => {
  return (
    <>
      {/* Top Bar Start */}
      <div className="top-bar d-none d-md-block">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <div className="top-bar-left">
                <div className="text">
                  <i className="fa fa-phone-alt"></i>
                  <p>+91-{SITE_CONFIG.phone}</p>
                </div>
                <div className="text">
                  <i className="fa fa-envelope"></i>
                  <p>{SITE_CONFIG.email}</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="top-bar-right">
                <div className="social">
                  <a href={SITE_CONFIG.twitter} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a href={SITE_CONFIG.facebook} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href={SITE_CONFIG.linkedin} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href={SITE_CONFIG.instagram} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-instagram"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Top Bar End */}

      {/* Nav Bar Start */}
      <div className="navbar navbar-expand-lg bg-dark navbar-dark" style={{ padding: 'unset' }}>
        <div className="container-fluid">
          <Link to="/" className="navbar-brand">
            <img src="/img/mdss_logo.png" alt="SSVASS Logo" />
          </Link>

          <button
            type="button"
            className="navbar-toggler"
            data-toggle="collapse"
            data-target="#navbarCollapse"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse justify-content-between" id="navbarCollapse">
            {isAdmin ? (
              // Admin Navigation
              <div className="navbar-nav ml-auto">
                <Link to="/admin" className="nav-item nav-link">Dashboard</Link>
                <Link to="/admin/visitors" className="nav-item nav-link">Visitors</Link>
                <Link to="/admin/enquiries" className="nav-item nav-link">Enquiries</Link>
                <Link to="/admin/blogs" className="nav-item nav-link">Blogs</Link>
                <Link to="/admin/galleries" className="nav-item nav-link">Galleries</Link>
                <Link to="/admin/exhibitions" className="nav-item nav-link">Exhibitions</Link>
                <Link to="/admin/notifications" className="nav-item nav-link">Notifications</Link>
                <Link to="/admin/profile" className="nav-item nav-link">Profile</Link>
              </div>
            ) : (
              // Public Navigation
              <div className="navbar-nav ml-auto">
                <Link to="/" className="nav-item nav-link active">Home</Link>
                <Link to="/about" className="nav-item nav-link">About us</Link>
                <Link to="/gallery" className="nav-item nav-link">Gallery</Link>
                <Link to="/stall" className="nav-item nav-link">Stall</Link>
                <Link to="/visitor" className="nav-item nav-link">Visitor</Link>
                <Link to="/contact" className="nav-item nav-link">Contact</Link>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Nav Bar End */}
    </>
  );
};

export default Header;
